module.exports = __webpack_public_path__ + "img/ico-notice.1f0604cd.svg";